// CommandPalette.js
// Simple command palette for VS Code-like IDE
import React, { useState, useRef, useEffect } from 'react';

const defaultCommands = [
  { label: 'Open File...', action: 'openFile' },
  { label: 'Save File', action: 'saveFile' },
  { label: 'Close Tab', action: 'closeTab' },
  { label: 'Toggle Sidebar', action: 'toggleSidebar' },
  { label: 'Go to Line...', action: 'goToLine' },
  { label: 'Open Settings', action: 'openSettings' },
  { label: 'Show Shortcuts', action: 'showShortcuts' },
  { label: 'Open Command Palette', action: 'openCommandPalette' },
];

const CommandPalette = ({ visible, onClose, onCommand, commands = defaultCommands }) => {
  const [query, setQuery] = useState('');
  const [filtered, setFiltered] = useState(commands);
  const inputRef = useRef();

  useEffect(() => {
    if (visible && inputRef.current) inputRef.current.focus();
    setFiltered(
      commands.filter((cmd) =>
        cmd.label.toLowerCase().includes(query.toLowerCase())
      )
    );
  }, [query, visible, commands]);

  useEffect(() => {
    if (!visible) setQuery('');
  }, [visible]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.25)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    }} onClick={onClose}>
      <div style={{
        marginTop: 120,
        background: '#232323',
        borderRadius: 8,
        boxShadow: '0 4px 32px #0008',
        minWidth: 400,
        maxWidth: 600,
        width: '100%',
        padding: 16,
      }} onClick={e => e.stopPropagation()}>
        <input
          ref={inputRef}
          value={query}
          onChange={e => setQuery(e.target.value)}
          placeholder="Type a command..."
          style={{
            width: '100%',
            padding: 10,
            fontSize: 16,
            background: '#181818',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            marginBottom: 8,
          }}
        />
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          {filtered.map((cmd, i) => (
            <div
              key={cmd.action}
              style={{
                padding: '8px 12px',
                color: '#fff',
                background: i === 0 ? '#333' : 'transparent',
                borderRadius: 4,
                cursor: 'pointer',
              }}
              onClick={() => onCommand(cmd)}
            >
              {cmd.label}
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ color: '#888', padding: 12 }}>No commands found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommandPalette;
